import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function RichTextEditor({ value, onChange }) {
    return (
        <div className="mb-4">
            <ReactQuill
                theme="snow"
                value={value}
                onChange={onChange}
                placeholder="Écrivez votre description ici..."
                className="
                    bg-white 
                    rounded-lg 
                    shadow-md
                    text-black
                    [&_.ql-editor]:min-h-[160px]
                    [&_.ql-editor]:text-black
                    [&_.ql-editor]:bg-white
                    [&_.ql-editor::before]:text-gray-400
                "
                modules={{
                    toolbar: [
                        [{ header: [1, 2, 3, false] }],
                        ["bold", "italic", "underline", "strike"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link"],
                        ["clean"],
                    ],
                }}
                formats={[
                    "header",
                    "bold",
                    "italic",
                    "underline",
                    "strike",
                    "list",
                    "bullet",
                    "link",
                ]}
            />
        </div>
    );
}
